import { AlertTriangle, Home, RefreshCw } from 'lucide-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

/**
 * Ekran beklenmedik bir hatayla düştüğünde görünen sayfa.
 *
 * Yönlendiricinin hazır hata ekranı İngilizceydi ("Something went wrong!"), yönlendirici dışındaki
 * bir hata ise bembeyaz ekran bırakıyordu. Ayrıntı kapalı kutuda: sorun bildirilirken kopyalanabilsin,
 * normal kullanıcının karşısına çıkmasın.
 */
export function SayfaHatasi({ error }: { error?: unknown }) {
  const ayrinti = error instanceof Error ? error.message : error ? String(error) : null;
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center"
      role="alert"
    >
      <div className="rounded-full bg-danger-soft p-3">
        <AlertTriangle className="size-6 text-danger" aria-hidden="true" />
      </div>
      <div className="space-y-1">
        <p className="text-base font-medium text-fg">Bu ekran açılırken bir sorun oluştu</p>
        <p className="max-w-md text-sm text-fg-muted">
          Verileriniz etkilenmedi. Sayfayı yenileyin; sorun sürerse aşağıdaki ayrıntıyla bildirin.
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button onClick={() => window.location.reload()}>
          <RefreshCw aria-hidden="true" />
          Sayfayı yenile
        </Button>
        <Button variant="secondary" onClick={() => window.location.assign('/')}>
          <Home aria-hidden="true" />
          Ana sayfaya dön
        </Button>
      </div>
      {ayrinti && (
        <details className="mt-2 max-w-xl text-xs text-fg-subtle">
          <summary className="cursor-pointer">Teknik ayrıntı</summary>
          <p className="mt-1 break-words font-code">{ayrinti}</p>
        </details>
      )}
    </div>
  );
}

/** Yönlendiricinin dışında kalan (giriş ekranı, oturum, kabuk) bir hata beyaz ekran bırakmasın. */
export class UygulamaHataSiniri extends Component<
  { children: ReactNode },
  { hata: unknown; dustu: boolean }
> {
  override state = { hata: null as unknown, dustu: false };

  static getDerivedStateFromError(hata: unknown) {
    return { hata, dustu: true };
  }

  override componentDidCatch(hata: Error, bilgi: ErrorInfo) {
    console.error('Ekran hatası', hata, bilgi.componentStack);
  }

  override render() {
    if (!this.state.dustu) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg">
        <SayfaHatasi error={this.state.hata} />
      </div>
    );
  }
}
